"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpritzArc = void 0;
var core_1 = require("../arc-types/core");
var Token_1 = __importDefault(require("./utils/Token"));
var IERC20Factory_1 = require("./typings/IERC20Factory");
var IOracleFactory_1 = require("./typings/IOracleFactory");
var CoreV4Factory_1 = require("./typings/CoreV4Factory");
var StateV1Factory_1 = require("./typings/StateV1Factory");
var StaticSyntheticTokenFactory_1 = require("./typings/StaticSyntheticTokenFactory");
var SpritzArc = /** @class */ (function () {
    function SpritzArc() {
    }
    SpritzArc.init = function (signer, addressBook) {
        return __awaiter(this, void 0, void 0, function () {
            var arc;
            return __generator(this, function (_a) {
                arc = new SpritzArc();
                arc.signer = signer;
                if (addressBook) {
                    arc.core = CoreV4Factory_1.CoreV4Factory.connect(addressBook.proxy, signer);
                    arc.state = StateV1Factory_1.StateV1Factory.connect(addressBook.state, signer);
                    arc.syntheticAsset = StaticSyntheticTokenFactory_1.StaticSyntheticTokenFactory.connect(addressBook.syntheticToken, signer);
                    arc.collateralAsset = IERC20Factory_1.IERC20Factory.connect(addressBook.collateralAsset, signer);
                    arc.oracle = IOracleFactory_1.IOracleFactory.connect(addressBook.oracle, signer);
                }
                return [2 /*return*/, arc];
            });
        });
    };
    SpritzArc.prototype.approveStableShare = function (amount, caller, overrides) {
        if (caller === void 0) { caller = this.signer; }
        if (overrides === void 0) { overrides = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var token, existingAllowance, _a, _b, tx;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        token = IERC20Factory_1.IERC20Factory.connect(this.collateralAsset.address, this.signer);
                        _b = (_a = token).allowance;
                        return [4 /*yield*/, this.signer.getAddress()];
                    case 1: return [4 /*yield*/, _b.apply(_a, [_c.sent(), this.core.address])];
                    case 2:
                        existingAllowance = _c.sent();
                        if (existingAllowance.gte(amount)) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, Token_1.default.approve(this.collateralAsset.address, caller || this.signer, this.core.address, amount, overrides)];
                    case 3:
                        tx = _c.sent();
                        return [2 /*return*/, tx.wait()];
                }
            });
        });
    };
    SpritzArc.prototype.approveSynthetic = function (amount, caller, overrides) {
        if (caller === void 0) { caller = this.signer; }
        if (overrides === void 0) { overrides = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var token, existingAllowance, _a, _b, tx;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        token = IERC20Factory_1.IERC20Factory.connect(this.syntheticAsset.address, this.signer);
                        _b = (_a = token).allowance;
                        return [4 /*yield*/, this.signer.getAddress()];
                    case 1: return [4 /*yield*/, _b.apply(_a, [_c.sent(), this.core.address])];
                    case 2:
                        existingAllowance = _c.sent();
                        if (existingAllowance.gte(amount)) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, Token_1.default.approve(this.syntheticAsset.address, caller || this.signer, this.core.address, amount, overrides)];
                    case 3:
                        tx = _c.sent();
                        return [2 /*return*/, tx.wait()];
                }
            });
        });
    };
    SpritzArc.prototype.openPosition = function (collateralAmount, borrowAmount, caller, overrides) {
        if (caller === void 0) { caller = this.signer; }
        if (overrides === void 0) { overrides = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var contract, tx;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCore(caller)];
                    case 1:
                        contract = _a.sent();
                        return [4 /*yield*/, contract.operateAction(core_1.Operation.Open, {
                                id: 0,
                                amountOne: collateralAmount,
                                amountTwo: borrowAmount,
                            }, overrides)];
                    case 2:
                        tx = _a.sent();
                        return [4 /*yield*/, this.parseActionTx(tx)];
                    case 3: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    SpritzArc.prototype.borrow = function (positionId, collateralAmount, borrowAmount, caller, overrides) {
        if (caller === void 0) { caller = this.signer; }
        if (overrides === void 0) { overrides = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var contract, tx;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCore(caller)];
                    case 1:
                        contract = _a.sent();
                        return [4 /*yield*/, contract.operateAction(core_1.Operation.Borrow, {
                                id: positionId,
                                amountOne: collateralAmount,
                                amountTwo: borrowAmount,
                            }, overrides)];
                    case 2:
                        tx = _a.sent();
                        return [4 /*yield*/, this.parseActionTx(tx)];
                    case 3: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    SpritzArc.prototype.repay = function (positionId, repaymentAmount, withdrawAmount, caller, overrides) {
        if (caller === void 0) { caller = this.signer; }
        if (overrides === void 0) { overrides = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var contract, tx;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCore(caller)];
                    case 1:
                        contract = _a.sent();
                        return [4 /*yield*/, contract.operateAction(core_1.Operation.Repay, {
                                id: positionId,
                                amountOne: repaymentAmount,
                                amountTwo: withdrawAmount,
                            }, overrides)];
                    case 2:
                        tx = _a.sent();
                        return [4 /*yield*/, this.parseActionTx(tx)];
                    case 3: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    SpritzArc.prototype.liquidatePosition = function (positionId, caller, overrides) {
        if (caller === void 0) { caller = this.signer; }
        if (overrides === void 0) { overrides = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var contract, tx;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCore(caller)];
                    case 1:
                        contract = _a.sent();
                        return [4 /*yield*/, contract.operateAction(core_1.Operation.Liquidate, {
                                id: positionId,
                                assetOne: '',
                                amountOne: 0,
                                assetTwo: '',
                                amountTwo: 0,
                            }, overrides)];
                    case 2:
                        tx = _a.sent();
                        return [4 /*yield*/, this.parseActionTx(tx)];
                    case 3: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    SpritzArc.prototype.setRiskParams = function (params, caller, overrides) {
        if (caller === void 0) { caller = this.signer; }
        if (overrides === void 0) { overrides = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var contract;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getState(caller)];
                    case 1:
                        contract = _a.sent();
                        return [4 /*yield*/, contract.setRiskParams(params, overrides)];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    SpritzArc.prototype.setMarketParams = function (params, caller, overrides) {
        if (caller === void 0) { caller = this.signer; }
        if (overrides === void 0) { overrides = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var contract;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getState(caller)];
                    case 1:
                        contract = _a.sent();
                        return [4 /*yield*/, contract.setMarketParams(params, overrides)];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    SpritzArc.prototype.parseActionTx = function (tx) {
        return __awaiter(this, void 0, void 0, function () {
            var receipt, decodedPosition, position, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, tx.wait()];
                    case 1:
                        receipt = _a.sent();
                        decodedPosition = {};
                        receipt.logs.forEach(function (log) {
                            try {
                                var decoded = _this.core.interface.decodeEventLog('ActionOperated', log.data, log.topics);
                                Object.entries(decoded).forEach(function (_a) {
                                    var key = _a[0], value = _a[1];
                                    decodedPosition[key] = value;
                                });
                            }
                            catch (_a) { }
                        });
                        position = {
                            owner: decodedPosition.updatedPosition[0],
                            collateralAsset: decodedPosition.updatedPosition[1],
                            borrowedAsset: decodedPosition.updatedPosition[2],
                            collateralAmount: {
                                sign: decodedPosition.updatedPosition[3][0],
                                value: decodedPosition.updatedPosition[3][1],
                            },
                            borrowedAmount: {
                                sign: decodedPosition.updatedPosition[4][0],
                                value: decodedPosition.updatedPosition[4][1],
                            },
                        };
                        result = {
                            operation: decodedPosition.operation,
                            params: {
                                id: decodedPosition.params[0],
                                assetOne: decodedPosition.params[1],
                                amountOne: decodedPosition.params[2],
                                assetTwo: decodedPosition.params[3],
                                amountTwo: decodedPosition.params[4],
                            },
                            updatedPosition: position,
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    SpritzArc.prototype.getCore = function (caller) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, CoreV4Factory_1.CoreV4Factory.connect(this.core.address, caller || this.signer)];
            });
        });
    };
    SpritzArc.prototype.getState = function (caller) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, StateV1Factory_1.StateV1Factory.connect(this.state.address, caller || this.signer)];
            });
        });
    };
    return SpritzArc;
}());
exports.SpritzArc = SpritzArc;
//# sourceMappingURL=SpritzArc.js.map